<form class="form-inline">
  <div class="form-group mx-sm-6 mb-6" style="margin-left: 20px;margin-top:18px">
    <label style="font-size: 14px">Durée d'échauffement (min)</label>

    <input
      type="number"
      class="form-control"
      [(ngModel)]="ignitionAlertConfiguration.value1"
      name="stopTime"
      (ngModelChange)="chooseStopTime($event)"
      placeholder="la durée"
      min="0"
      step="1"
      style="width: 82px;border-radius: 10px;margin-left: 10px;"
    />



<!-------------------Email-component---------------------->

    <div style="margin-top: 25px">
      <app-email-manager [enableGlobalConfigToAllVehicules]="enableGlobalConfigToAllVehicules" [emailMode]="alert.emailMode" [enableGlobalConfig]="enableGlobalConfig" [emailsHash]="alert.emails" (onChange)="emailSettings($event)"></app-email-manager>

    </div>

    <div class="form-group" style="margin-top: -45px;margin-left: 460px">
      <label style="margin-right: 10px">Activer l'alert</label>
      <div class="input-group">
        <mat-slide-toggle [(ngModel)]="alert.isActive" name="isActive"></mat-slide-toggle>
      </div>
    </div>









    <input *ngIf="!stopTimeSelectMode" type="number" name="stopTime" [(ngModel)]="stopTime" class="form-control" placeholder="Durée d'arrêt">

    <i *ngIf="!stopTimeSelectMode" class="fa fa-times" style="color: #aa1111" (click)="stopTimeSelectMode = true;ignitionAlertConfiguration.value1='10'"></i>
  </div>

  <div  class="advanced-link" style="margin-left: 15px" *ngIf="!showAdvancedSettings" (click)="collapseAdvancedSettings()">
    <span class="link"  style="margin-right: 5px;text-decoration: none">paramétrage avancé</span>
    <i class="fa fa-plus-square"></i>

  </div>

  <div class="advanced-link" style="margin-left: 15px" *ngIf="showAdvancedSettings" (click)="collapseAdvancedSettings()">
    <span class="link" style="margin-right: 5px;text-decoration: none">masquer paramétrage avancé</span>
    <i class="fa fa-minus-square"></i>

  </div>

  <div style="margin-top: 10px;margin-left: 25px">
    <app-cron-settings *ngIf="showAdvancedSettings" [cron]="cronAlertConfiguration"></app-cron-settings>

  </div>


  <br>



  <button type="submit" class="btn btn-flat btn-primary pull-right"  style="margin-top: 45px;border-radius: 15px" (click)="save()">
      Sauvegarder
  </button>

</form>
